import IService from "@api/iService";
import {BuyBonusCodeModel} from "@models/user/bonusCodes";
import {IPersonalBonusCode, IUseBonusCodeResult, IUsedBonusCode} from "@interfaces/user/bonusCodes";

export default class BonusService extends IService {

    buyBonusCode(model: BuyBonusCodeModel) {
        return this.putApi<IPersonalBonusCode>('/api/user/bonus/personal/', model)
    }

    fetchUserUsedBonusCodes() {
        return this.getAndThrowApi<IUsedBonusCode[]>('/api/user/bonus/used/');
    }

    fetchUserPersonalBonusCodes() {
        return this.getAndThrowApi<IPersonalBonusCode[]>('/api/user/bonus/personal/');
    }

    activateUserBonusCode(code: string) {
        return this.postApi<IUseBonusCodeResult>('/api/user/bonus/use/', { code });
    }
}